import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CREAM_PETITION_UPDATE_PROMOTION_ASK = createFcmDetails('cream_petition_update_promotion_ask', {
	owner: 'supporters pack',
	context: 'petition page',
	description:
		'Indicates that the "promote" button should be displayed when the petition is signed, promotable, and the user does not own the petition.',
	template: {
		enabled: true,
		// rolloutExperiment: '',
		// togglePUMA: false,
		// hidePUMA: false,
	},
	import: false,
});
